import { useMutation } from '@tanstack/react-query';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../utils';

const completeAssessmentTimeout = 15000;

const completeMentalityAssessment = async () => {
  const callable = httpsCallable(functions, 'completeAssessment', { timeout: completeAssessmentTimeout });

  const response = await callable();

  return response.data;
};

export default function useCompleteMentalityAssessment() {
  return useMutation({
    mutationFn: completeMentalityAssessment,
    onError: (error) => {
      console.log(`error completing assessment: ${error}`);
    },
    onSuccess: (data) => {
      console.log('completed assessment', data);
    }
  });
}
